import { useState } from "react";
import { Modal } from "antd";
import {
  FileImageOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FileUnknownOutlined,
  LinkOutlined,
  DownloadOutlined,
  CloseOutlined,
} from "@ant-design/icons";
// import FileBrowser from "./file-browser";
import { download } from "@/utils/public";
import "./index.less";

// const mockList: any = [
//   {
//     text: "陕西省工作报告.docx",
//     type: "fileDoc",
//     url: "https://oss-saas-frontend-cdn.oss-cn-beijing.aliyuncs.com/files/%E9%99%95%E8%A5%BF%E7%9C%81%E6%8A%80%E6%9C%AF%E5%88%9B%E6%96%B0%E7%A4%BA%E8%8C%83%E4%BC%81%E4%B8%9A%E8%AE%A4%E5%AE%9A%E7%AE%A1%E7%90%86%E5%8A%9E%E6%B3%95(%E4%BF%AE%E8%AE%A2).docx",
//   },
//   {
//     text: "中外记者见面会.docx",
//     type: "fileDoc",
//     url: "https://oss-saas-frontend-cdn.oss-cn-beijing.aliyuncs.com/files/%E4%B8%AD%E5%A4%96%E8%AE%B0%E8%80%85%E8%A7%81%E9%9D%A2.docx",
//   },
//   {
//     text: "中外记者见面会.jpg",
//     type: "filePicture",
//     url: "https://oss-saas-frontend-cdn.oss-cn-beijing.aliyuncs.com/files/%E4%B8%AD%E5%A4%96%E8%AE%B0%E8%80%85%E8%A7%81%E9%9D%A2.jpg",
//   },
//   {
//     text: "中外记者见面会.pdf",
//     type: "filePdf",
//     url: "https://oss-saas-frontend-cdn.oss-cn-beijing.aliyuncs.com/files/%E4%B8%AD%E5%A4%96%E8%AE%B0%E8%80%85%E8%A7%81%E9%9D%A21.pdf",
//   },
//   {
//     text: "中外记者见面会.xlsx",
//     type: "fileExcel",
//     url: "https://oss-saas-frontend-cdn.oss-cn-beijing.aliyuncs.com/files/%E9%87%87%E9%9B%86%E6%95%B0%E6%8D%AE%E9%A1%B9.xlsx",
//   },
//   {
//     text: "盲校课程标准",
//     type: "serviceLink",
//     url: "http://www.moe.gov.cn/srcsite/A06/s3331/201612/t20161213_291722.html",
//   },
// ];

const CardRelationMatters = (props) => {
  //注释
  const { chatInstance, msg } = props;
  const [open, setOpen] = useState(false);
  const [fileData, setFileData] = useState({
    text: "",
    type: "serviceLink",
    url: "",
  });

  // 文件预览
  const handleFileViewer = (data) => {
    const { type, url } = data;
    if (type === "serviceLink") {
      window.open(url, "_blank");
      return;
    }
    setOpen(true);
    setFileData(data);
  };

  // 对应文件渲染图标
  const renderFileIcon = (fileType) => {
    switch (fileType) {
      case "filePicture":
        return <FileImageOutlined style={{ color: "#567fe6" }} />;
      case "fileDoc":
        return <FileWordOutlined style={{ color: "#567fe6" }} />;
      case "fileExcel":
        return <FileExcelOutlined style={{ color: "#567fe6" }} />;
      case "filePdf":
        return <FilePdfOutlined style={{ color: "#567fe6" }} />;
      case "serviceLink":
        return <LinkOutlined style={{ color: "#567fe6" }} />;
      default:
        return <FileUnknownOutlined style={{ color: "#567fe6" }} />;
    }
  };

  return (
    <div>
      <div className="card_hyper-links">
        <div className="msg-line">
          <h4 className="inner-card__title">附件</h4>
          <ul>
            {msg.attachmentList.map((item, index) => {
              const { text, type } = item;
              return (
                <li className="attachment_item" key={index}>
                  <div
                    className="link_item"
                    onClick={() => handleFileViewer(item)}
                  >
                    {/* {renderFileIcon(type)} */}
                    <span>{text}</span>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <Modal
        title={fileData.text}
        open={open}
        onCancel={() => setOpen(false)}
        closeIcon={
          <>
            <DownloadOutlined
              className="icon_download"
              onClick={() => {
                download(fileData.url);
              }}
            />
            <CloseOutlined
              className="icon_close"
              onClick={() => setOpen(false)}
            />
          </>
        }
        width={848}
        footer={null}
        bodyStyle={{ height: "600px", overflow: "auto" }}
        destroyOnClose
      >
        {/* <FileBrowser file={fileData} /> */}
      </Modal>
    </div>
  );
};

export default CardRelationMatters;
